import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from '@mui/material';
import DOMPurify from 'dompurify';
import * as React from 'react';
import { HelpInfoData, helpText } from '../../../../sic-lib/types/infoData';

interface Props {
    emailProvider: number;
    isOpen: boolean;
    onCloseHandler: () => void;
}

export default function DialogUserEmailInstructions({
    emailProvider,
    isOpen,
    onCloseHandler,
}: Props) {
    const itemProvider = React.useMemo(() => {
        switch (emailProvider) {
            case 1:
                return 'Gmail Setup';
            case 3:
                return 'Office 365 Setup';
            default:
                return 'Unknown Provider';
        }
    }, [emailProvider]);

    const sanitizeHTML = (dirtyHtml: string) => {
        const config = {
            ADD_ATTR: ['target'],
        };
        return { __html: DOMPurify.sanitize(dirtyHtml, config) };
    };

    // function to get image for the proper provider and specific title
    const getImage = (item: string) => {
        if (emailProvider !== 1) return;
        switch (item) {
            case '2.':
                return (
                    <img
                        src="/google_sign_in_step2.png"
                        alt="Sign_In_Setup"
                        width="450"
                        height="150"
                    />
                );
            case '3.':
                return (
                    <img
                        src="/google_sign_in_step3.png"
                        alt="Sign_In_Setup"
                        width="450"
                        height="150"
                    />
                );
            case '5.':
                return (
                    <img
                        src="/google_sign_in_step5.png"
                        alt="Sign_In_Setup"
                        width="450"
                        height="200"
                    />
                );
            case '6.':
                return (
                    <img
                        src="/google_sign_in_step6.png"
                        alt="Sign_In_Setup"
                        width="450"
                        height="150"
                    />
                );
            case '7.':
                return (
                    <img
                        src="/google_sign_in_step7.png"
                        alt="Sign_In_Setup"
                        width="450"
                        height="250"
                    />
                );
            default:
                return;
        }
    };

    return (
        <Dialog maxWidth="md" open={isOpen} onClose={onCloseHandler}>
            <DialogTitle>{itemProvider}</DialogTitle>
            <DialogContent dividers>
                {helpText[itemProvider as keyof HelpInfoData] &&
                    helpText[itemProvider as keyof HelpInfoData].map((item, index) => {
                        return (
                            <Grid container direction="column" flexWrap="nowrap" key={index}>
                                <Grid
                                    item
                                    container
                                    flexWrap="nowrap"
                                    alignItems="center"
                                    spacing={0.5}
                                >
                                    <Grid item>
                                        <Typography component="p" variant="subtitle2">
                                            {item.title}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography
                                            component="div"
                                            variant="caption"
                                            dangerouslySetInnerHTML={sanitizeHTML(item.paragraph)}
                                        />
                                    </Grid>
                                </Grid>
                                {emailProvider === 1 && (
                                    <Grid item container display="flex" justifyContent="center">
                                        {getImage(item.title)}
                                    </Grid>
                                )}
                            </Grid>
                        );
                    })}
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseHandler} color="secondary" variant="outlined">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}
